const SHARE_PROMPTS_URL = 'https://rovo.com/';

/**
 * Generates a shareable link for one or more prompts.
 *
 * @param promptIds - The prompt IDs to include in the share link
 * @returns The complete share URL
 */
export const generateShareLink = (promptIds: string[] | string): string => {
	const ids = Array.isArray(promptIds) ? promptIds : [promptIds];
	const url = new URL(SHARE_PROMPTS_URL);
	url.searchParams.set('promptIds', ids.join(','));
	return url.toString();
};
